import { render } from "./MattersArisingReport.vue?vue&type=template&id=06ea101c&scoped=true"
import script from "./MattersArisingReport.vue?vue&type=script&lang=js"
export * from "./MattersArisingReport.vue?vue&type=script&lang=js"

import "./MattersArisingReport.vue?vue&type=style&index=0&id=06ea101c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ea101c"]])

export default __exports__